"use client";
import { API } from "../../globalhelper/api";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showAlert, navUrl } from "../../redux/Common/commonActions";
import { toast } from "react-toastify";

// GET
export function useApiQuery(key, url, options) {
  const dispatch = useDispatch();

  const queryFn = async () => {
    const response = await API.get(url);
    return response;
  };

  const {
    data: queryData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: key,
    queryFn,
    ...options,
  });

  useEffect(() => {
    if (queryData) {
      const message =
        typeof queryData?.res?.message === "object"
          ? queryData?.res?.message?.message ||
          "Problem With Connecting Data Server"
          : queryData?.res?.message;

      dispatch(
        showAlert(message, queryData?.res?.status || "success")
      );

      if (message)
        toast.success(message, { position: "top-right" });

      setTimeout(
        () => dispatch(showAlert("", "info")) || undefined,
        5000
      );

      if (
        queryData?.res?.status === "warning" &&
        queryData?.res?.type === "unauthorized"
      ) {
        dispatch(navUrl("/"));
        dispatch(showAlert(message, queryData?.res?.status));
        toast.error(message, { position: "top-right" });
        setTimeout(() => window.location.reload(), 1000);
      }
    }
  }, [queryData?.res?.status, dispatch]);

  return {
    data: queryData?.res?.data,
    isLoading,
    error,
    refetch,
  };
}

// POST / PUT / DELETE
export function useApiMutation(
  url,
  method = "post",
  options
) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (data) => API[method](url, data),
    ...options,
    onSuccess: (data, variables, context) => {
      if (data) {
        const message =
          typeof data?.res?.message === "object"
            ? data?.res?.message?.message ||
            "Problem With Connecting Data Server"
            : data?.res?.message;

        if (message) {
          dispatch(
            showAlert(message, data?.res?.status || "success")
          );

          if (data?.res?.status === "error" || data?.type === "failed") {
            toast.error(message, { position: "top-right" });
          } else {
            toast.success(message, { position: "top-right" });
          }

          setTimeout(
            () => dispatch(showAlert("", "info")) || undefined,
            5000
          );
        }

        if (
          data?.res?.status === "warning" &&
          (data?.res?.type === "unauthorized" || data?.type === "unauthorized")
        ) {
          dispatch(navUrl("/"));
          if (message) {
            dispatch(showAlert(message, data?.res?.status));
            toast.error(message, { position: "top-right" });
          }
          setTimeout(() => window.location.reload(), 1000);
        }
      }

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      toast.error(error.message || "An error occurred", { position: "top-right" });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
}
